export type BpaProgressSummary = {
  complete: number;
  inProgress: number;
  notStarted: number;
  total: number;
};

export function summariseBpaProgress(rows: Array<{ status: string | null }>): BpaProgressSummary {
  let complete = 0;
  let notStarted = 0;

  for (const row of rows) {
    if (row.status === "complete") {
      complete += 1;
    } else if (row.status === "not_started") {
      notStarted += 1;
    }
  }

  const total = rows.length;
  const inProgress = total - complete - notStarted;

  return { complete, inProgress, notStarted, total };
}
